import { type DependencyList, type EffectCallback, useEffect, useRef } from 'react';

function useUpdateEffect(effect: EffectCallback, deps: DependencyList = []): void {
  const firstRun = useRef(true);

  useEffect(
    () => {
      if (firstRun.current) {
        firstRun.current = false;

        return;
      }

      return effect();
    },
    // eslint-disable-next-line
    deps
  );
}

export default useUpdateEffect;
